<script setup>
import Title from '@components/Title.vue'
import Subtitle from '@components/Subtitle.vue'
import CTAButton from '@components/CTAButton.vue'
</script>

<template>
  <div
    class="mx-auto max-w-7xl px-0 sm:px-6 lg:px-8"
    dusk="HeadingSection"
  >
    <div class="mx-auto max-w-2xl lg:text-center flex flex-col gap-6">
      <Title>
        ABN Registration Online
      </Title>
      <Subtitle>
        Apply for your Australian Business Number in 5 minutes
      </Subtitle>
      <CTAButton
        href="/abn-register"
        text="Start my ABN Application"
        class="w-full lg:w-auto mx-auto"
        size="xl"
      />
    </div>
  </div>
</template>
